import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick";

import { binder } from "./libs/binder";
import { constants } from "./modules/module";
import { fullHeightPage } from "./modules/fullHeightPage";
import { animationOnScroll } from "./modules/animationOnScroll";
import { customSelect } from "./modules/customSelect";
import { accordion } from "./modules/accordion";
import { cardsSlider } from "./modules/cardsSlider";
import { headerNav } from "./modules/headerNav";
import { articleNav } from "./modules/articleNav";
import { articleProgress } from "./modules/articleProgress";
import { leavePopup } from "./modules/leavePopup";
import { footerSpecialBar } from "./modules/footerSpecialBar";
import { imageSlider } from "./modules/imageSlider";
import {qrPopup} from "./modules/qrPopap";




binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".has-animation": animationOnScroll,
        ".accordion": accordion,
        ".cards-slider": cardsSlider,
        ".header": headerNav,
        "article.content .page-nav": articleNav,
        "#progress-bar": articleProgress,
        ".footer-special-bar": footerSpecialBar,
        ".image-slider": imageSlider,
        ".leave-popup": leavePopup,
        ".qr-popup-opener": qrPopup,


    },
    runTests: false
});

window.initCustomSelect = function () {
    customSelect();
};



// WEBPACK FOOTER //
// ./assets/js/global.js